import { render, staticRenderFns } from "./StatusPicker.vue?vue&type=template&id=55880236&scoped=true&"
import script from "./StatusPicker.vue?vue&type=script&lang=js&"
export * from "./StatusPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55880236",
  null
  
)

export default component.exports